import { render, staticRenderFns } from "./StockTake.vue?vue&type=template&id=128b4c10"
import script from "./StockTake.vue?vue&type=script&lang=js"
export * from "./StockTake.vue?vue&type=script&lang=js"
import style0 from "./StockTake.vue?vue&type=style&index=0&id=128b4c10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports